import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const mobileMenuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(e.target as Node)) {
        setIsMobileMenuOpen(false);
      }
    };
    if (isMobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMobileMenuOpen]);

  const navLinks = [
    { label: '首页', href: '/' },
    { label: '情感故事', href: '/category/qinggan-gushi' },
    { label: '成长记忆', href: '/category/chengzhang-jiyi' },
    { label: '心理分析', href: '/category/xinli-fenxi' },
    { label: '青春文学', href: '/category/qingchun-wenxue' },
    { label: '关于我们', href: '/about' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link
          to="/"
          className="text-xl font-semibold text-foreground-900 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
        >
          朋友的姐姐
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap transition-colors duration-200 ${
                location.pathname === link.href
                  ? 'text-primary-500 bg-primary-50 font-medium'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors duration-200 cursor-pointer"
          aria-label="打开菜单"
        >
          <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-foreground-900`}></i>
        </button>
      </nav>

      {isMobileMenuOpen && (
        <div
          ref={mobileMenuRef}
          className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3"
        >
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`block px-3 py-2.5 rounded-lg text-sm transition-colors duration-200 ${
                location.pathname === link.href
                  ? 'text-primary-500 bg-primary-50 font-medium'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}